import { useParams, useSearchParams } from "react-router-dom";
import ProductDetails from "@/app/components/product/ProductDetails";
import ProductDetailsSkeleton from "@/app/components/product/ProductDetailsSkeleton";
import { useGetProductQuery } from "@/lib/api/apiSlice";
import { useShowInitialLoader } from "@/lib/hooks";

export default function ProductPage() {
  const params = useParams<{ id: string; variant?: string }>();
  const [searchParams] = useSearchParams();
  const id = params.id ?? searchParams.get("id") ?? undefined;
  const variant = params.variant ?? searchParams.get("variant") ?? undefined;

  const {
    data: product,
    isLoading,
    isError,
  } = useGetProductQuery(id!, { skip: !id });

  const showLoader = useShowInitialLoader(isLoading, product);

  if (!id) {
    return (
      <div className="flex min-h-screen items-center justify-center px-4">
        <p className="text-lg">Product not found.</p>
      </div>
    );
  }

  if (showLoader) {
    return <ProductDetailsSkeleton />;
  }

  if (isError || !product) {
    return (
      <div className="flex min-h-screen items-center justify-center px-4">
        <p className="text-lg">Product not found.</p>
      </div>
    );
  }

  return (
    <ProductDetails
      isPreview={false}
      product={product}
      defaultVariantId={variant}
    />
  );
}
